<template>
	<div class="layer-project" data-project-name="ezn-foundation">
		<!-- Project Name -->
		<div class="layer-project-detail">
			<section class="project-visual">
				<div>
					<h1 class="project-tit">
						<span class="c-red">이지앤</span> <span>가족복지재단</span>
						<br /><span class="c-red">EZN</span><span>FOUNDATION</span>
					</h1>
					<a href="http://www.eznfoundation.or.kr" class="link" target="_blank"
						>www.eznfoundation.or.kr</a
					>
				</div>
			</section>
			<!-- Details [s] -->
			<section class="project-overview">
				<div class="inner-section">
					<img
						src=""
						alt=""
						data-src="/static/img/project-detail/ezn-foundation/temp-overview@w.png"
					/>
				</div>
			</section>
			<section class="section pc-main full">
				<div class="inner-section">
					<img
						src=""
						alt=""
						data-src="/static/img/project-detail/ezn-foundation/temp-pc-main01@w.jpg"
					/>
					<img
						src=""
						alt=""
						data-src="/static/img/project-detail/ezn-foundation/temp-pc-main02@w.jpg"
					/>
				</div>
			</section>
			<section class="section pc-contents full">
				<div class="inner-section">
					<img
						src=""
						alt=""
						data-src="/static/img/project-detail/ezn-foundation/temp-pc-contents01@w.jpg"
					/>
					<img
						src=""
						alt=""
						data-src="/static/img/project-detail/ezn-foundation/temp-pc-contents02@w.jpg"
					/>
					<img
						src=""
						alt=""
						data-src="/static/img/project-detail/ezn-foundation/temp-pc-contents03@w.jpg"
					/>
					<img
						src=""
						alt=""
						data-src="/static/img/project-detail/ezn-foundation/temp-pc-contents04@w.jpg"
					/>
					<img
						src=""
						alt=""
						data-src="/static/img/project-detail/ezn-foundation/temp-pc-contents05@w.jpg"
					/>
				</div>
			</section>
			<section class="section mobile-main full">
				<div class="inner-section">
					<img
						src=""
						alt=""
						data-src="/static/img/project-detail/ezn-foundation/temp-mobile-main@w.jpg"
					/>
				</div>
			</section>
			<section class="section mobile-contents full">
				<div class="inner-section">
					<img
						src=""
						alt=""
						data-src="/static/img/project-detail/ezn-foundation/temp-mobile-contents01@w.jpg"
					/>
					<img
						src=""
						alt=""
						data-src="/static/img/project-detail/ezn-foundation/temp-mobile-contents02@w.jpg"
					/>
					<img
						src=""
						alt=""
						data-src="/static/img/project-detail/ezn-foundation/temp-mobile-contents03@w.jpg"
					/>
					<img
						src=""
						alt=""
						data-src="/static/img/project-detail/ezn-foundation/temp-mobile-contents04@w.jpg"
					/>
					<img
						src=""
						alt=""
						data-src="/static/img/project-detail/ezn-foundation/temp-mobile-contents05@w.jpg"
					/>
				</div>
			</section>
			<section class="section style">
				<div class="inner-section">
					<img
						src=""
						alt=""
						data-src="/static/img/project-detail/ezn-foundation/temp-style@w.png"
					/>
				</div>
			</section>
			<!-- Details [e] -->
			<section class="project-client">
				<strong class="a11y-hidden">이지앤 가족복지재단</strong>
			</section>
		</div>

		<app-pjmove></app-pjmove>
	</div>
</template>

<script>
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();
	},
	methods: {},
};
</script>
<!-- css 추가 -->
<style scoped>
@import "../../static/css/projects.css"; /* Common Project Detail Page */
.project-tit .nowrap {
	display: inline-block;
}
.project-client {
	background: url(/static/img/project-detail/ezn-foundation/ci.png) 50% / auto
		20px no-repeat;
}
.c-red {
	color: #d91c1c;
}

@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/ezn-foundation/bg-overview@m.jpg);
	}
	.project-visual > div {
		padding-top: 0;
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		height: 850px;
		background-image: url(/static/img/project-detail/ezn-foundation/bg-overview@t.jpg);
	}
	.project-tit .block {
		display: block;
	}
	.project-client {
		background-size: auto 40px;
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		height: 820px;
		background-image: url(/static/img/project-detail/ezn-foundation/bg-overview@w.jpg);
	}
	.project-visual > div {
		padding-top: 0;
	}
}

/* project-overview */
.project-overview {
	background-color: #a4988a;
}
.project-overview .inner-section {
	padding: 0;
}
@media screen and (max-width: 711px) {
	.project-overview {
		padding: 48px 15px;
	}
}
@media screen and (min-width: 712px) {
	.project-overview {
		padding: 65px 40px;
	}
}
@media screen and (min-width: 1280px) {
	.project-overview {
		padding: 70px 0 80px;
	}
}

/* PC Main */
.section.pc-main {
	padding: 0;
}
@media screen and (min-width: 712px) {
}
@media screen and (min-width: 1280px) {
}

/* PC Contents */
.section.pc-contents {
	padding: 0;
}
@media screen and (min-width: 712px) {
}
@media screen and (min-width: 1280px) {
}

/* Mobile Main */
.section.mobile-main {
	padding: 0;
}
@media screen and (min-width: 712px) {
}
@media screen and (min-width: 1280px) {
}

/* Mobile Contents */
.section.mobile-contents {
	padding: 0;
}
@media screen and (min-width: 712px) {
}
@media screen and (min-width: 1280px) {
}

/* Style */
.section.style {
	background-color: #fff;
}
@media screen and (min-width: 712px) {
	.section.style {
		padding: 50px 15px;
	}
}
@media screen and (min-width: 1280px) {
	.section.style {
		padding: 126px 0;
	}
	.section.style img {
		width: 1282px;
	}
}

/* Project Client */
.project-client {
	background-color: #313131;
}
</style>


// WEBPACK FOOTER //
// src/projects/ezn-foundation.vue